<template>
   <v-layout align-start>
      <v-flex xs12 :style="$vuetify.breakpoint.smAndUp ? 'margin: 0px 2% 0px 0px' : ''">
         <v-snackbar
            v-model="snackbar"
            :color="snackColor"
            right
            bottom
            :timeout="4000"
         >
            {{ snackText }}
            <template #action="{ attrs }">
               <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                  Cerrar
               </v-btn>
            </template>
         </v-snackbar>

         <v-container fluid class="white mt-1">
            <v-toolbar flat color="white" class="pt-2">
               <v-toolbar-title style="font-weight: 500">
                  Comprobantes de Pago — Colecturía Digital y Externa
               </v-toolbar-title>
               <v-divider class="mx-2" inset vertical></v-divider>
               <v-spacer></v-spacer>
            </v-toolbar>

            <!-- El nombre va debajo del título, y no en una columna, porque la tabla
                 ya no lleva carnet ni nombre: es el único lugar donde se ve de quién
                 son los comprobantes, así que se muestra en grande y en rojo. Solo
                 aparece cuando todos los resultados son del mismo alumno, que es lo
                 que ocurre al buscar por carnet. -->
            <div v-if="alumnoNombre" class="px-4 pb-3">
               <span class="text-h6 grey--text text--darken-3">
                  Nombre del alumno:
               </span>
               <span class="text-h6 font-weight-bold red--text text--darken-2">
                  {{ alumnoNombre }}
               </span>
            </div>

            <!-- FILTROS

                 Cuatro puntos de quiebre en lugar de tres, porque con el rango de
                 fechas ya son cinco filtros y no entran en una fila de md:

                   xs  uno debajo del otro
                   sm  de a dos, que es lo que admiten 600px sin apretarse
                   md  de a tres, con los botones en su propia fila
                   lg  los cinco en una fila, con los botones al final

                 Los botones necesitan lg2: "Buscar" con su ícono más "Limpiar"
                 piden unos 200px, y con menos se parten o se salen de la tarjeta. -->
            <v-layout wrap class="px-4 pb-2">
               <v-flex xs12 sm6 md4 lg2 class="pr-2">
                  <v-text-field
                     v-model="filtroCarnet"
                     label="Carnet"
                     placeholder="2021-CU-501"
                     clearable
                     color="primary"
                     @keyup.enter="buscar"
                  ></v-text-field>
               </v-flex>
               <v-flex xs12 sm6 md4 lg2 class="pr-2 mt-2">
                  <CustomDatePicker
                     :date="filtroFechaDesde"
                     label="Desde"
                     min="2015-01-01"
                     clearable
                     txt-style="width: 100%; font-size: 1.15rem;"
                     @updateFecha="filtroFechaDesde = $event"
                  />
               </v-flex>
               <v-flex xs12 sm6 md4 lg2 class="pr-2 mt-2">
                  <!-- El mínimo se amarra a "Desde" para que el calendario no deje
                       armar un rango invertido; tecleando sí se puede, y de eso se
                       encarga la validación de buscar(). -->
                  <CustomDatePicker
                     :date="filtroFechaHasta"
                     label="Hasta"
                     :min="filtroFechaDesde || '2015-01-01'"
                     clearable
                     txt-style="width: 100%; font-size: 1.15rem;"
                     @updateFecha="filtroFechaHasta = $event"
                  />
               </v-flex>
               <v-flex xs12 sm6 md4 lg2 class="pr-2">
                  <v-text-field
                     v-model="filtroDescripcion"
                     label="Descripción"
                     placeholder="Cuota, arancel, idioma..."
                     clearable
                     color="primary"
                     @keyup.enter="buscar"
                  ></v-text-field>
               </v-flex>
               <v-flex xs12 sm6 md4 lg2 class="pr-2">
                  <v-text-field
                     v-model="filtroAutorizacion"
                     label="Autorización"
                     placeholder="076929"
                     clearable
                     color="primary"
                     @keyup.enter="buscar"
                  ></v-text-field>
               </v-flex>
               <v-flex xs12 md12 lg2 class="d-flex align-center">
                  <v-btn color="primary" :loading="loading" @click="buscar">
                     <v-icon left>fas fa-search</v-icon> Buscar
                  </v-btn>
                  <v-btn text class="ml-2" @click="limpiar">Limpiar</v-btn>
               </v-flex>
            </v-layout>

           

            <v-alert
               v-if="sinAcceso"
               type="warning"
               dense
               text
               class="mx-4 caption"
            >
               No tiene habilitado ningún tipo de comprobante, así que no se mostrarán
               resultados. Solicite acceso al administrador.
            </v-alert>
            <v-row
               v-else-if="accesoCargado"
               align="center"
               dense
               class="px-4 pb-2 mt-0"
            >
               <v-col cols="auto" class="py-0 pr-1">
                  <span
                     class="caption grey--text text--darken-2 font-weight-medium"
                  >
                     Tipos habilitados
                  </span>
               </v-col>
               <v-col class="py-0">
                  <!-- Mismo patrón que el selector de año del Historial de pagos:
                       etiqueta chica y un v-chip-group de chips `filter`, rellenos
                       cuando están activos y en contorno cuando no.

                       La selección es simple —sin `multiple`— porque se pidió ver
                       una categoría a la vez: al hacer clic sobre el chip que ya
                       está activo el v-chip-group deja el valor sin definir y la
                       tabla vuelve a mostrar las tres. El recorte es local, sobre lo
                       que ya devolvió la búsqueda: no vuelve a consultar el API. -->
                  <v-chip-group v-model="categoriaFiltro">
                     <v-chip
                        v-for="t in tiposPermitidos"
                        :key="t"
                        :value="t"
                        small
                        filter
                        class="chip-categoria font-weight-bold"
                        :color="colorCategoria"
                        :dark="categoriaFiltro === t"
                        :outlined="categoriaFiltro !== t"
                     >
                        {{ t }}
                     </v-chip>
                  </v-chip-group>
               </v-col>
            </v-row>

            <!-- TABLA -->
            <div style="overflow-x: auto">
               <v-data-table
                  :headers="headers"
                  :items="items"
                  :loading="loading"
                  loading-text="Buscando comprobantes..."
                  :footer-props="{
                     itemsPerPageOptions: [10, 25, 50],
                     itemsPerPageText: 'Filas por página:'
                  }"
                  class="mt-2 tabla-comprobantes"
               >
                  <template #item.concepto="{ item }">
                     <div class="d-flex align-center">
                        <span>{{ item.concepto }}</span>
                        <v-chip
                           v-if="item.cantidad > 1"
                           x-small
                           color="primary"
                           dark
                           class="ml-2 flex-shrink-0"
                        >
                           {{ item.cantidad }} pagos
                        </v-chip>
                     </div>
                  </template>

                  <template #item.categoria="{ item }">
                     <v-chip
                        x-small
                        dark
                        class="font-weight-bold"
                        :color="colorCategoria"
                     >
                        {{ item.categoria }}
                     </v-chip>
                  </template>

                  <template #item.total="{ item }">
                     <span class="text-no-wrap">$ {{ numFormatIntl(item.total) }}</span>
                  </template>

                  <template #item.fecha="{ item }">
                     <span class="text-no-wrap">{{ item.fecha }}</span>
                  </template>

                  <template #item.ver="{ item }">
                     <v-btn icon small color="primary" title="Ver comprobante" @click="ver(item)">
                        <v-icon small>fas fa-eye</v-icon>
                     </v-btn>
                  </template>

                  <template #no-data>
                     <span>{{ mensajeVacio }}</span>
                  </template>
               </v-data-table>
            </div>
         </v-container>
      </v-flex>
   </v-layout>
</template>

<script>
import axios from 'axios'
import { authComputed } from '../helpers'
// Mismo mixin de formato que usa Colecturía Digital (numFormatIntl, toFixedRegex):
// el comprobante debe mostrar los montos exactamente igual.
import formatters from '../mixins/formattersLib'

const CustomDatePicker = () => import('./custom/CustomDatePicker')
// Mismo generador que usa Colecturía Digital: trae las fuentes (TimesNewRoman)
// que el formato del comprobante necesita.
const getReporteLib = () => import('../mixins/reporteLib')

// Carreras que en el comprobante se rotulan como "ESCUELA DE POSGRADOS" en vez
// de "FACULTAD:". Copiado de ColecturiaDigital.vue para no alterar ese componente.
const LISTA_POSGRADOS = new Set([
   'MAESTRIA EN GERENCIA DE SERVICIO DE SALUD',
   'MAESTRIA EN DIRECCION ESTRATEGICA DE EMPRESAS',
   'MAESTRIA EN ASESORIA EDUCATIVA',
   'MAESTRIA EN ESTUDIOS JUDICIALES',
   'MAESTRIA EN ATENCION INTEGRAL DE LA PRIMERA INFANCIA',
   'MAESTRIA EN GERENCIA Y GESTION AMBIENTAL',
   'MAESTRIA EN GESTION Y DESARROLLO TURISTICO',
   'MAESTRIA EN SEGURIDAD INFORMATICA',
   'MAESTRIA EN SEGURIDAD INFORMATICA - VIRTUAL',
   'MAESTRIA EN INVESTIGACION EDUCATIVA',
   'MAESTRIA EN GERENCIA Y GESTION AMBIENTAL - VIRTUAL',
   'DOCTORADO EN EDUCACION',
   'DOCTORADO EN CIENCIAS AMBIENTALES',
   'DOCTORADO EN DIRECCION ESTRATEGICA DE EMPRESAS',
   'DOCTORADO EN INGENIERIA AMBIENTAL'
])

export default {
   name: 'ComprobantesPago',
   components: {
      CustomDatePicker
   },
   mixins: [formatters],
   computed: {
      ...authComputed,
      // Solo los comprobantes de los tipos habilitados para este usuario.
      // El backend devuelve todos; el recorte se hace acá.
      itemsPermitidos() {
         return this.itemsCrudos.filter((i) =>
            this.tiposPermitidos.includes(i.categoria)
         )
      },
      // Lo que se ve en la tabla: lo habilitado y, si hay un chip seleccionado,
      // recortado además a esa categoría.
      items() {
         return this.categoriaFiltro
            ? this.itemsPermitidos.filter(
                 (i) => i.categoria === this.categoriaFiltro
              )
            : this.itemsPermitidos
      },
      sinAcceso() {
         return this.accesoCargado && !this.tiposPermitidos.length
      },
      mensajeVacio() {
         if (this.sinAcceso) {
            return 'No tiene habilitado ningún tipo de comprobante. Solicite acceso al administrador.'
         }
         if (!this.busquedaHecha) {
            return 'Indique un criterio y haga clic en Buscar.'
         }
         // Con un chip seleccionado el vacío puede ser del filtro y no de la
         // búsqueda, así que se dice cuál de los dos.
         if (this.categoriaFiltro && this.itemsPermitidos.length) {
            return `Ninguno de los comprobantes encontrados es de ${this.categoriaFiltro}.`
         }
         // Distingue "no hay nada" de "hay, pero no puede verlo".
         return this.itemsCrudos.length
            ? 'Se encontraron comprobantes, pero ninguno de los tipos que tiene habilitados.'
            : 'No se encontraron comprobantes con esos criterios.'
      },
      /**
       * Nombre que acompaña al título. La tabla ya no trae carnet ni nombre, así
       * que el alumno se identifica acá, y solo tiene sentido cuando todos los
       * resultados son de la misma persona —búsqueda por carnet o por
       * autorización—. En una búsqueda por rango de fechas cada fila puede ser de
       * un alumno distinto, y entonces no se muestra ninguno.
       */
      alumnoNombre() {
         const nombres = new Set(
            this.itemsPermitidos
               .map((i) => (i.nombre || '').trim())
               .filter((n) => n !== '')
         )
         return nombres.size === 1 ? Array.from(nombres)[0] : ''
      }
   },
   data: () => ({
      loading: false,
      busquedaHecha: false,
      snackbar: false,
      snackColor: 'error',
      snackText: '',
      filtroCarnet: '',
      filtroFechaDesde: null,
      filtroFechaHasta: null,
      filtroDescripcion: '',
      filtroAutorizacion: '',
      // Lo que devolvió el API; `items` es esto ya filtrado por acceso.
      itemsCrudos: [],
      // Tipos de comprobante habilitados para este usuario (IDIOMAS/CUOTAS/ARANCELES)
      tiposPermitidos: [],
      // Chip seleccionado; en null la tabla muestra todas las categorías.
      categoriaFiltro: null,
      accesoCargado: false,
      // Sello "CANCELADO" del comprobante; se carga una vez al abrir la pantalla.
      selloCanceladoNoDate: null,
      // Las tres categorías van del granate institucional —el que ya usaba
      // CUOTAS—, tanto en el chip que filtra como en la columna "Tipo". Si alguna
      // vez vuelven a diferenciarse por color, este es el único lugar que tocar.
      colorCategoria: '#6C1C19',
      // Carnet y nombre no van como columnas: el alumno se muestra una sola vez
      // junto al título (ver alumnoNombre).
      headers: [
         { text: 'Concepto', value: 'concepto', class: 'titulo' },
         { text: 'Tipo', value: 'categoria', class: 'titulo', align: 'center' },
         // Solo lo traen las cuotas; en aranceles e idiomas la celda queda vacía.
         {
            text: 'Talonario',
            value: 'numeroTalonario',
            class: 'titulo',
            align: 'center'
         },
         { text: 'Total', value: 'total', class: 'titulo', align: 'right' },
         { text: 'Fecha', value: 'fecha', class: 'titulo' },
         { text: 'Autorización', value: 'autorizacion', class: 'titulo' },
         {
            text: 'Ver',
            value: 'ver',
            class: 'titulo',
            sortable: false,
            align: 'center'
         }
      ]
   }),
   created() {
      // Validando acceso al componente (permiso 34)
      if (!this.permController(33, 'ver')) {
         this.$router.push({ name: 'inicio' })
         return
      }
      // Mismo sello que usa el comprobante de Colecturía Digital.
      this.toDataURL('/assets/sello-cancelado-nodate-400.png').then((result) => {
         this.selloCanceladoNoDate = result
      })
      this.cargarAcceso()
   },
   methods: {
      cargarAcceso() {
         // El userId se manda desde el cliente, igual que hace App.vue con
         // api/permisos/{sub}: el middleware de autenticación solo corre en
         // Producción, así que en Development el servidor no puede deducirlo.
         const userId = (this.oidcUser && this.oidcUser.sub) || ''
         if (!userId) {
            this.tiposPermitidos = []
            this.accesoCargado = true
            return
         }

         axios
            .get('api/ComprobanteAcceso/' + encodeURIComponent(userId))
            .then((r) => {
               this.tiposPermitidos = (r.data && r.data.tipos) || []
            })
            .catch(() => {
               // Sin poder leer el acceso no se muestra nada: es preferible a exponer
               // comprobantes que el usuario quizá no deba ver.
               this.tiposPermitidos = []
            })
            .finally(() => {
               this.accesoCargado = true
            })
      },
      buscar() {
         const carnet = (this.filtroCarnet || '').trim()
         const descripcion = (this.filtroDescripcion || '').trim()
         const autorizacion = (this.filtroAutorizacion || '').trim()

         const desde = this.filtroFechaDesde
         const hasta = this.filtroFechaHasta

         if (!carnet && !desde && !hasta && !descripcion && !autorizacion) {
            this.showSnack('Indique al menos un criterio de búsqueda.')
            return
         }

         // Las fechas vienen en yyyy-MM-dd, así que se comparan como texto.
         if (desde && hasta && desde > hasta) {
            this.showSnack(
               'La fecha "Desde" no puede ser mayor que la fecha "Hasta".'
            )
            return
         }

         this.loading = true
         const params = {}
         if (carnet) params.carnet = carnet.toUpperCase()
         // Cualquiera de los dos extremos puede ir solo: sin "Hasta" la búsqueda
         // llega hasta el último pago, y sin "Desde" arranca desde el primero.
         if (desde) params.fechaDesde = desde
         if (hasta) params.fechaHasta = hasta
         if (descripcion) params.descripcion = descripcion
         if (autorizacion) params.autorizacion = autorizacion

         axios
            .get('api/Pago/comprobantes/buscar', { params })
            .then((r) => {
               this.itemsCrudos = r.data || []
               this.busquedaHecha = true
               if (!this.items.length) {
                  this.showSnack(this.mensajeVacio, 'info')
               }
            })
            .catch((error) => {
               const msg =
                  error.response && typeof error.response.data === 'string'
                     ? error.response.data
                     : 'Error al buscar los comprobantes.'
               this.showSnack(msg)
            })
            .finally(() => {
               this.loading = false
            })
      },
      limpiar() {
         this.filtroCarnet = ''
         this.filtroFechaDesde = null
         this.filtroFechaHasta = null
         this.filtroDescripcion = ''
         this.filtroAutorizacion = ''
         this.categoriaFiltro = null
         this.itemsCrudos = []
         this.busquedaHecha = false
      },
      /**
       * Abre el comprobante en una pestaña nueva, desde donde se puede descargar.
       * El documento replica el mismo formato que genera Colecturía Digital en su
       * Historial de pagos (generarComprobantePago): media carta, sello CANCELADO,
       * marca de agua, cabecera de la universidad y pie de "COMPROBANTE ALUMNO".
       */
      ver(item) {
         const tipo = (item.tipoPago || '').toLowerCase() === 'cuota' ? 'cuota' : 'arancel'
         const fechaFile = (item.fecha || '').substr(0, 10).replace(/\//g, '-')
         const filename =
            'Comprobante ' +
            (item.autorizacion || '') +
            ' Colecturia Digital ' +
            fechaFile +
            '.pdf'

         const dd = this.definicionComprobante(item, tipo)
         getReporteLib().then((res) => res.generarPDF('open', dd, filename))
      },
      /**
       * Réplica de la definición de ColecturiaDigital.generarComprobantePago.
       * Se mantiene la misma estructura de tablas, tamaños y textos para que el
       * comprobante salga idéntico al que el alumno descarga desde su historial.
       */
      definicionComprobante(item, tipo) {
         const detalle = item.detalle || []

         // Alto de página: se sigue el criterio de Colecturía Digital, que agranda
         // la hoja con más de cuatro líneas, sean cuotas o aranceles.
         //
         // Antes se replicaba además la variante de Externa, que solo la agranda
         // para cuotas, y por eso un comprobante externo de más de cuatro aranceles
         // salía en media carta apretada mientras el mismo pago en Digital salía
         // holgado. Como el alto también posiciona el sello —absolutePosition usa
         // pageHeight - 116— la diferencia además lo corría de lugar, y los dos
         // comprobantes terminaban pareciendo documentos distintos.
         let pageHeight = 396.0
         if (detalle.length > 4) {
            pageHeight = 460.0
         }

         const primero = detalle[0] || {}

         // Fila del código de materia: Digital la muestra solo si tiene código Y
         // nombre (ColecturiaDigital.vue:7352); con uno solo la deja en cuerpo 1,
         // que es tan chico que no se ve.
         //
         // Acá se pedía únicamente el código, y un examen diferido trae código sin
         // nombre: aparecía una línea que en Digital no existe y, por ser una fila
         // de más, empujaba todo el resto del comprobante hacia abajo. Es la misma
         // clase de desfase que causaba la fila del NPE.
         //
         // El detalle no incluye el nombre de la materia —ComprobantePagoDetalle
         // solo trae MateriaCodigo—, así que la fila queda siempre oculta, igual
         // que en Digital. No se pierde información: el código de materia ya se
         // imprime dentro de la descripción del arancel.
         const materiaNombre = ''
         const mostrarMateria = !!primero.materiaCodigo && materiaNombre !== ''

         // El detalle de aranceles se agrupa por código: el original imprime una fila
         // por arancel con su cantidad, y acá cada pago es una unidad de ese arancel.
         const getDetalleAranceles = () => {
            const result = []

            const agrupados = this.agruparAranceles(detalle)

            // Cuerpo 8 fijo, y no un umbral como en las cuotas. Suena arbitrario,
            // así que conviene explicarlo.
            //
            // Colecturía Digital escribe (ColecturiaDigital.vue:7005):
            //
            //     var fS = this.aranceles.length < 5 ? 8 : 7
            //     this.detallePagoArancel.forEach(...)
            //
            // Cuenta un arreglo y dibuja otro. `aranceles` es el catálogo del
            // formulario de pago, no el detalle del comprobante, y en el flujo del
            // historial nunca se llena: queda vacío, 0 < 5 y el resultado es
            // siempre 8, tenga el comprobante dos líneas o veinte.
            //
            // Medir el arreglo que de verdad se imprime da 7 en cuanto hay cinco
            // aranceles, y ahí los dos documentos dejan de coincidir. Comparando
            // los PDF salió justamente eso: Digital en 8 y esta pantalla en 7.
            //
            // Como el diseño de Digital es el aprobado, se replica su resultado.
            // Si algún día se corrige aquel cálculo, hay que corregir este también.
            const fS = 8

            result.push([
               { text: 'CODIGO', alignment: 'right', bold: true, fontSize: fS },
               { text: 'CANT.', alignment: 'right', bold: true, fontSize: fS },
               { text: 'DESCRIPCION', bold: true, fontSize: fS },
               { text: ' ', fontSize: fS },
               {
                  text: 'PRECIO',
                  fontSize: fS,
                  bold: true,
                  margin: [0, 0, 35, 0],
                  alignment: 'right'
               }
            ])

            agrupados.forEach((a) => {
               result.push([
                  { text: a.codigo, alignment: 'right', fontSize: fS },
                  { text: a.cantidad, alignment: 'right', fontSize: fS },
                  {
                     text:
                        a.descripcion +
                        ' ' +
                        (a.materiaCodigo ? a.materiaCodigo : '') +
                        (a.programa ? `, ${a.programa}, NIVEL ${a.nivel}` : ''),
                     fontSize: fS
                  },
                  { text: '$', fontSize: fS },
                  {
                     text: this.toFixedRegex(Number(a.total), 2),
                     fontSize: fS,
                     margin: [0, 0, 35, 0],
                     alignment: 'right'
                  }
               ])
            })

            result.push([
               {
                  text: 'TOTAL A PAGAR ',
                  fontSize: 10,
                  margin: [0, 0, 15, 0],
                  bold: true,
                  alignment: 'right',
                  colSpan: 3
               },
               {},
               {},
               { text: '$', fontSize: 10, bold: true },
               {
                  text: this.numFormatIntl(item.total),
                  fontSize: 10,
                  bold: true,
                  margin: [0, 0, 35, 0],
                  alignment: 'right'
               }
            ])
            return result
         }

         const getDetalleCuotas = () => {
            const result = []
            const fS = detalle.length < 4 ? 8 : 7

            detalle.forEach((c) => {
               result.push([
                  {
                     text: `CUOTA ${c.numeroCuota}`,
                     alignment: 'right',
                     fontSize: fS
                  },
                  {
                     text: `CICLO ${c.periodoLectivo} ${
                        c.tipoBeca == null
                           ? ''
                           : `CON BECA ${Number(c.descuento)}%`
                     }`,
                     fontSize: fS
                  },
                  { text: '$', fontSize: fS },
                  {
                     text: this.toFixedRegex(Number(c.monto), 2),
                     fontSize: fS,
                     margin: [0, 0, 35, 0],
                     alignment: 'right'
                  }
               ])
            })

            result.push([
               {
                  text: 'TOTAL A PAGAR',
                  fontSize: 10,
                  margin: [0, 0, 15, 0],
                  bold: true,
                  alignment: 'right',
                  colSpan: 2
               },
               {},
               { text: '$', fontSize: 10, bold: true },
               {
                  text: this.numFormatIntl(item.total),
                  fontSize: 10,
                  bold: true,
                  margin: [0, 0, 35, 0],
                  alignment: 'right'
               }
            ])
            return result
         }

         const getCuotasNpes = () =>
            detalle
               .map((d) => d.npe)
               .filter(Boolean)
               .join('\n')

         // Cabecera: Colecturía Externa imprime otro juego de filas que Digital.
         // En Externa quien paga es un cliente (puede no ser alumno de carrera), así
         // que se muestran DUI y nombre, y no hay fila de facultad.
         const esExterno = !!item.esExterno

         // Los alumnos del Colegio Madre de la Iglesia pagan desde Externa pero sí
         // tienen contrato, así que se les agrega el grado académico bajo el nombre.
         // Se detecta por tener contrato (de ahí sale el grado); son los únicos
         // externos que lo tienen. Su carnet además lleva el tercer segmento < 100,
         // por ejemplo 2022-BB-020.
         // Externa imprime siempre las mismas tres filas —CARNET, DUI, CLIENTE—,
         // sin excepciones: ColecturiaExterna.vue las tiene fijas dentro de su
         // generarComprobantePago, sin ninguna condición.
         //
         // Antes había acá una variante para el Colegio Madre de la Iglesia que
         // cambiaba DUI por la unidad educativa y rotulaba ALUMNO en vez de
         // CLIENTE. Es un caso que Externa no hace: el comprobante real de un
         // alumno del colegio sale con DUI y CLIENTE como cualquier otro pago
         // externo. Esa rama generaba una cabecera que no existe en ningún lado.
         const filasEncabezado = esExterno
            ? [
                 ['CARNET:', { text: item.alumnoCarnet, colSpan: 2 }, {}],
                 ['DUI:', { text: item.dui || '', colSpan: 2 }, {}],
                 ['CLIENTE:', { text: item.nombre || '', colSpan: 2 }, {}]
              ]
            : [
                 ['CARNET:', { text: item.alumnoCarnet, colSpan: 2 }, {}],
                 ['ALUMNO:', { text: item.nombre || '', colSpan: 2 }, {}],
                 ['CARRERA:', { text: item.carrera || '', colSpan: 2 }, {}],
                 [
                    {
                       // Los posgrados llevan otro rótulo, igual que en el original.
                       text: LISTA_POSGRADOS.has(
                          (item.carrera || '').trim().toUpperCase()
                       )
                          ? 'ESCUELA DE POSGRADOS'
                          : 'FACULTAD:\n' + (item.unidadAcademica || '').trim(),
                       bold: true,
                       alignment: 'center',
                       colSpan: 3
                    },
                    {},
                    {}
                 ]
              ]

         return {
            pageSize: { width: 306.0, height: pageHeight },
            background: () => {
               // El sello solo se dibuja si la imagen alcanzó a cargarse.
               if (!this.selloCanceladoNoDate) return null
               return {
                  image: this.selloCanceladoNoDate,
                  absolutePosition: { x: 72, y: pageHeight - 116 },
                  width: 170,
                  opacity: 0.3
               }
            },
            watermark: {
               text: 'CANCELADO',
               color: 'red',
               angle: -35,
               fontSize: 40,
               opacity: 0.3,
               bold: true
            },
            pageMargins: [20, 20],
            footer: (currentPage, pageCount) => {
               return {
                  margin: [20, 0],
                  fontSize: 10,
                  alignment: 'right',
                  text: `Página ${currentPage.toString()} de ${pageCount}`
               }
            },
            content: [
               {
                  table: {
                     heights: 390.0,
                     widths: ['*'],
                     body: [
                        [
                           {
                              table: {
                                 widths: [60, '*', '*'],
                                 body: [
                                    [
                                       {
                                          text: 'UNIVERSIDAD CATÓLICA\nDE EL SALVADOR',
                                          font: 'TimesNewRoman',
                                          fontSize: 10,
                                          bold: true,
                                          alignment: 'center',
                                          colSpan: 3
                                       },
                                       {},
                                       {}
                                    ],
                                    ...filasEncabezado,
                                    [
                                       {
                                          text: '_',
                                          color: 'white',
                                          fontSize: 6,
                                          colSpan: 3
                                       },
                                       {},
                                       {}
                                    ],
                                    [
                                       {
                                          text:
                                             'MANDAMIENTO DE PAGO DE ' +
                                             (tipo == 'arancel'
                                                ? 'ARANCELES'
                                                : 'CUOTAS'),
                                          bold: true,
                                          fontSize: 10,
                                          alignment: 'center',
                                          colSpan: 3
                                       },
                                       {},
                                       {}
                                    ],
                                    [
                                       {
                                          table: {
                                             widths:
                                                tipo == 'arancel'
                                                   ? [35, 25, 120, 5, '*']
                                                   : [60, 120, 5, '*'],
                                             body:
                                                tipo == 'arancel'
                                                   ? getDetalleAranceles()
                                                   : getDetalleCuotas()
                                          },
                                          layout: 'noBorders',
                                          colSpan: 3
                                       },
                                       {},
                                       {}
                                    ],
                                    [
                                       {
                                          text: [
                                             {
                                                text: mostrarMateria
                                                   ? primero.materiaCodigo + ': '
                                                   : '',
                                                bold: true
                                             },
                                             mostrarMateria ? materiaNombre : ''
                                          ],
                                          fontSize: mostrarMateria ? 8 : 1,
                                          align: 'justify',
                                          margin: [20, 0],
                                          colSpan: 3
                                       },
                                       {},
                                       {}
                                    ],
                                    [
                                       {
                                          text: '_',
                                          color: 'white',
                                          fontSize: 3,
                                          colSpan: 3
                                       },
                                       {},
                                       {}
                                    ],
                                    [
                                       {
                                          text: tipo == 'arancel' ? '' : 'NPE',
                                          fontSize: tipo == 'arancel' ? 1 : 9,
                                          bold: true,
                                          alignment: 'right'
                                       },
                                       {
                                          // En aranceles va vacío, igual que en
                                          // Colecturía Digital, donde esta celda es
                                          // `this.npe` y en el flujo del historial
                                          // nunca se llena: un arancel suelto no
                                          // tiene NPE de talonario.
                                          //
                                          // Acá sí había valor, porque el dato viene
                                          // de Pagos.Npe, y esa fila de más empujaba
                                          // TODO el resto del comprobante 9,4 puntos
                                          // hacia abajo. Era lo que hacía ver los dos
                                          // documentos desalineados de la mitad para
                                          // abajo, no un problema de márgenes.
                                          //
                                          // En cuotas sí se imprimen, como en Digital.
                                          text:
                                             tipo == 'arancel'
                                                ? ''
                                                : getCuotasNpes(),
                                          fontSize: 8,
                                          bold: true,
                                          colSpan: 2
                                       },
                                       {}
                                    ],
                                    [
                                       {
                                          text: 'Referencia',
                                          fontSize: 9,
                                          bold: true,
                                          alignment: 'right'
                                       },
                                       {
                                          text: item.referencia || '',
                                          fontSize: 9,
                                          bold: true,
                                          colSpan: 2
                                       },
                                       {}
                                    ],
                                    [
                                       {
                                          text: 'Autorización',
                                          fontSize: 9,
                                          bold: true,
                                          alignment: 'right'
                                       },
                                       {
                                          text: item.autorizacion || '',
                                          fontSize: 9,
                                          bold: true,
                                          colSpan: 2
                                       },
                                       {}
                                    ],
                                    [
                                       {
                                          text: 'Fecha de pago',
                                          fontSize: 9,
                                          bold: true,
                                          alignment: 'right'
                                       },
                                       {
                                          text: item.fecha || '',
                                          fontSize: 9,
                                          bold: true,
                                          colSpan: 2
                                       },
                                       {}
                                    ],
                                    [
                                       {
                                          text: esExterno
                                             ? 'COMPROBANTE CLIENTE'
                                             : 'COMPROBANTE ALUMNO',
                                          bold: true,
                                          alignment: 'center',
                                          colSpan: 3
                                       },
                                       {},
                                       {}
                                    ],
                                    [
                                       {
                                          text: 'El presente mandamiento, no sustituye facturas o comprobantes de crédito fiscal.',
                                          bold: true,
                                          alignment: 'center',
                                          colSpan: 3,
                                          margin: [20, 5]
                                       },
                                       {},
                                       {}
                                    ]
                                 ]
                              },
                              margin: [0, 0, 15, 0],
                              layout: 'noBorders'
                           }
                        ]
                     ]
                  },
                  layout: 'noBorders'
               }
            ],
            defaultStyle: { fontSize: 9 }
         }
      },
      /**
       * Junta los pagos que comparten arancel en una sola línea con su cantidad,
       * que es como los muestra el comprobante original (una fila por arancel).
       */
      agruparAranceles(detalle) {
         const mapa = new Map()
         detalle.forEach((d) => {
            const clave = d.arancelCodigo || d.arancel || 's/c'
            if (!mapa.has(clave)) {
               mapa.set(clave, {
                  codigo: d.arancelCodigo || '',
                  descripcion: d.arancel || '',
                  materiaCodigo: d.materiaCodigo || '',
                  programa: d.programa || '',
                  nivel: d.nivel || '',
                  cantidad: 0,
                  total: 0
               })
            }
            const fila = mapa.get(clave)
            fila.cantidad += 1
            fila.total += Number(d.monto || 0)
         })
         return Array.from(mapa.values())
      },
      // Carga una imagen del sitio como data URL, igual que ColecturiaDigital.
      toDataURL(url) {
         return new Promise(function (resolve) {
            var xhr = new XMLHttpRequest()
            xhr.onload = function () {
               var reader = new FileReader()
               reader.onloadend = function () {
                  resolve(reader.result)
               }
               reader.readAsDataURL(xhr.response)
            }
            xhr.open('GET', url)
            xhr.responseType = 'blob'
            xhr.send()
         })
      },
      showSnack(text, tipo) {
         this.snackText = text
         this.snackColor = tipo === 'info' ? 'primary' : 'error'
         this.snackbar = true
      }
   }
}
</script>

<style scoped>
/* Chip activo: relleno granate con la letra y el visto del filtro en blanco.
   El `dark` del v-chip ya pone blanca la letra, pero el ícono del filtro es un
   v-icon aparte que toma el color del tema, y sobre el granate se veía apagado. */
.chip-categoria.v-chip--active,
.chip-categoria.v-chip--active >>> .v-icon {
   color: #fff !important;
}

.tabla-comprobantes >>> td,
.tabla-comprobantes >>> th {
   padding-left: 8px !important;
   padding-right: 8px !important;
}
</style>
